import React, { useEffect, useState, useContext } from 'react';
import { GlobalContext } from '../utils/GlobalContext';
import { CONSTANT } from '../utils/constants';
import '../../css/GenericBuilder/DiamondPage.css';
import { useKeenSlider } from 'keen-slider/react';
import '../../css/SingleRingBuilder/DiamondModal.css';

import 'keen-slider/keen-slider.min.css';

export const DiamondDetailsModal = ({ closeDiamondModal, closeAllModel, handleAddDiamond, diamondDetailsTemp, diamondDetailsPricesTemp, singlePage = 'false', handleBasketPreivew = null, handleAppointmentSchdule = null, colorCodes=null }) => {
    const { updateLayerParams, layerparam,flags } = useContext(GlobalContext);
    const [selectedStock, setSelectedStock] = useState(diamondDetailsTemp);
    const [diamondPriceDetails, setDiamondPriceDetails] = useState(diamondDetailsPricesTemp);
    const [imagesList, setImagesList] = useState(() => {
        const list = [];
        if (selectedStock?.Lab !== 'gcal') {
            if (selectedStock?.cert_link) {
                list.push({ name: selectedStock.cert_link, icon: `${CONSTANT.BASE_URL}/assets/images/report.png` });
            }
            if (selectedStock?.image_link) {
                list.push({ name: selectedStock.image_link, icon: `${CONSTANT.BASE_URL}/assets/images/diamond.png` });
            }
            if (selectedStock?.video_link) {
                list.push({ name: selectedStock.video_link, icon: `${CONSTANT.BASE_URL}/assets/images/video-diamond.png` });
            }
        }
        return list;
    });
    const [currentImage, setCurrentImage] = useState(() => {
        return selectedStock?.Lab === 'gcal' ? '' : selectedStock?.cert_link || '';
    });
    const [sliderRef] = useKeenSlider({
        vertical: false,
        slides: {
            perView: 4,
            spacing: 10,
        },
    });

    return (
        <>
            <div className="modal-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 20px', background: colorCodes?.[0] || '#00355D', borderRadius: '8px 8px 0 0', position: 'sticky', top: 0, zIndex: 1 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <div style={{ background: 'rgba(255,255,255,0.15)', borderRadius: '8px', padding: '8px 10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
                        </svg>
                    </div>
                    <div>
                        <h4 style={{ color: 'white', margin: 0, fontSize: '17px', fontWeight: '600' }}>Diamond Details</h4>
                        <p style={{ color: 'rgba(255,255,255,0.55)', margin: 0, fontSize: '12px' }}>Center stone information</p>
                    </div>
                </div>
                <div style={{ display: 'flex', gap: '8px' }}>
                    <button type="button" onClick={closeDiamondModal} style={{ background: 'rgba(255,255,255,0.15)', border: 'none', color: 'white', borderRadius: '6px', padding: '5px 12px', cursor: 'pointer', fontSize: '13px', fontWeight: '600' }}>← Back</button>
                    <button type="button" onClick={closeDiamondModal} style={{ background: 'rgba(255,255,255,0.15)', border: 'none', color: 'white', borderRadius: '6px', width: '30px', height: '30px', cursor: 'pointer', fontSize: '18px', lineHeight: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>×</button>
                </div>
            </div>
            <div className="modal-body" style={{paddingBottom: `20px`}}>
                {Object.keys(selectedStock).length > 0 && (
                    <div className="row">
                        {/* Left: Carousel */}
                        <div className="col-12 col-sm-6 col-md-6 col-lg-6">
                            <div className="carousel carousel-stage">
                                <div style={{
                                    flex: 1,
                                    height: '500px',
                                    background: 'linear-gradient(to bottom, #cfdce8, #cfdce8)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}>
                                    {currentImage ? (
                                        <iframe
                                            src={currentImage}
                                            title="Diamond"
                                            style={{ width: '100%', height: '400px', border: 'none' }}
                                        />
                                    ) : (
                                        <span>No preview available</span>
                                    )}
                                </div>

                                <div ref={sliderRef} className="keen-slider diamond-slider" style={{ width: '100%' }}>
                                    {imagesList.length > 0 && imagesList.map((img, index) => (
                                        <div
                                            key={index}
                                            className="keen-slider__slide"
                                            onMouseEnter={() => setCurrentImage(img.name)}
                                            style={{
                                                border: currentImage === img.name ? '2px solid #00345d' : '1px solid #ccc',
                                                padding: '5px',
                                                cursor: 'pointer',
                                                backgroundColor: '#fff',
                                                textAlign: 'center',
                                            }}
                                        >
                                            <img src={img.icon} alt={`thumb-${index}`} style={{ width: '80px' }} />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* Right: Info */}
                        <div className="col-12 col-sm-6 col-md-6 col-lg-6">
                            <ul className="list-group">
                                <li className="list-group-item mt-4">
                                    <h5 style={{ color: 'var(--color-theme)', fontWeight: 900, fontSize: '15px' }}>
                                        {selectedStock?.shape} {selectedStock?.carat} Ct {selectedStock?.color} {selectedStock?.clarity} {(!flags?.['HIDE_DIAMOND_PRICE'] || flags?.['HIDE_DIAMOND_PRICE'] == 'No') && (<>Price (MSRP): {selectedStock?.prices}</>)}
                                    </h5>
                                    <span className="pull-right" onClick={closeAllModel}><a className='btn btn-primary'>Add Diamond</a></span>
                                </li>
                            </ul>
                            <hr />
                            <ul className="list-group mt-4">
                                <li className="list-group-item active">STONE INFORMATION :</li>
                                <div className="row">
                                    <div className="col-12">
                                        <table className="table table-text-color">
                                            {!flags?.['HIDE_DIAMOND_COLUMN'] || flags?.['HIDE_DIAMOND_COLUMN'] == 'No' ? (
                                                <tbody>  
                                                    <tr><td>Stock#</td><td>{selectedStock?.id}</td><td>Polish</td><td>{selectedStock?.Polish}</td></tr>
                                                    <tr><td>Shape</td><td>{selectedStock?.shape}</td><td>Sym</td><td>{selectedStock?.Symm}</td></tr>
                                                    <tr><td>Carat</td><td>{selectedStock?.carat}</td><td>Deptd%</td><td>{selectedStock?.deptd || 0}%</td></tr>
                                                    <tr><td>Color</td><td>{selectedStock?.color}</td><td>Table%</td><td>{selectedStock?.table || 0}%</td></tr>
                                                    <tr><td>Clarity</td><td>{selectedStock?.clarity}</td><td>Measurements</td><td>{selectedStock?.measurement}</td></tr>
                                                    <tr><td>Cut</td><td>{selectedStock?.Cut}</td><td>Girdle</td><td>{selectedStock?.girdle || '---'}</td></tr>
                                                    <tr><td>Lab</td><td>{selectedStock?.Lab}</td><td>Certificate#</td><td>{selectedStock?.certificate || '----'}</td></tr>
                                                </tbody>
                                            ):(
                                                <tbody>  
                                                    <tr>
                                                        <td>Stock#</td><td>{selectedStock?.id}</td>
                                                        <td>Polish</td><td>{selectedStock?.Polish}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Shape</td><td>{selectedStock?.shape}</td>
                                                        <td>Sym</td><td>{selectedStock?.Symm}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Carat</td><td>{selectedStock?.carat}</td>
                                                        <td>Measurements</td><td>{selectedStock?.measurement}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Color</td><td>{selectedStock?.color}</td>
                                                        <td>Girdle</td><td>{selectedStock?.girdle || '---'}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Clarity</td><td>{selectedStock?.clarity}</td>
                                                        <td>Certificate#</td><td>{selectedStock?.certificate || '----'}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Lab</td><td>{selectedStock?.Lab}</td>
                                                    </tr>
                                                </tbody>
                                            )}
                                        </table>
                                    </div>
                                </div>
                            </ul>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};
